import React from "react";
import { Highcharts } from "../charts/HighCharts";
import { useDispatch } from "react-redux";
import HighchartsReact from "highcharts-react-official";
import { setclearAll, setvenn } from "../../../redux/actions/DisplayChart";

const VennChart = (props) => {
  const { single, title, colors } = props;
  const dispatch = useDispatch();
  //on click function of venn chart
  const onVennClick = (event) => {
    let obj;
    obj = {
      x: null,
      y: null,
      split: event.point.sets,
    };
    obj && dispatch(setvenn(obj)); //set venn values
    dispatch(setclearAll("venn")); //clear all charts state except "venn"
  };
  const options = {
    series: [
      {
        type: "venn",
        name: "Venn Diagram",
        data: single,
        cursor: "pointer",
        point: {
          events: {
            click: (event) => onVennClick(event),
          },
        },
        colors: colors && colors,
        dataLabels: {
          allowOverlap: false,
        },
      },
    ],
    title: {
      text: title,
    },
    credits: {
      enabled: false,
    },
  };

  return (
    <div>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default VennChart;
